<template>
  <div>
    <div id="toolbar">
      <div class="row">
        <div class="col-md-8">
          <button class="btn btn-light mr-3" @click="
            $refs.chart.add({
              id: +new Date(),
              x: 10,
              y: 10,
              name: 'Nouveau',
              type: 'operation',
              approvers: [],
            })
          ">
            <i class="fa fa-stop-circle mr-1 h5 my-auto text-success"></i>
            {{ $t('pages.flowchart.btn.state') }}
          </button>
          <button class="btn btn-light mr-2" @click="
            $refs.chart.add({
              id: +new Date(),
              x: 10,
              y: 10,
              name: 'Nouveau',
              type: 'condition',
              approvers: [],
            })
          ">
            <i class="fa fa-question mr-1 h5 my-auto text-danger"></i>
            {{ $t('pages.flowchart.btn.condition') }}
          </button>
          <!-- <button class="btn btn-light mr-2" @click="
            $refs.chart.add({
              id: +new Date(),
              x: 10,
              y: 10,
              name: 'Nouveau',
              type: 'condition',
              approvers: [],
            })
          ">
            <i class="fa fa-cog mr-1 h5 my-auto text-primary"></i>
            {{ $t('pages.flowchart.btn.service') }}
          </button> -->
          <button class="btn btn-danger mr-2" @click="$refs.chart.remove()">
            <i class="fa fa-trash h5 my-auto text-white"></i>
          </button>
          <button class="btn btn-success mr-2" @click="$refs.chart.editCurrent()">
            <i class="fa fa-pen h5 my-auto text-white"></i>
          </button>
        </div>
        <div class="col-md-4 text-right">
          <button :disabled="isLoading" class="btn btn-primary mr-2" @click="$refs.chart.save()">
            <i class="fa fa-save mr-1 h5 my-auto text-white"></i>
            {{ $t('pages.flowchart.btn.register') }}
          </button>
        </div>
      </div>
    </div>
    <flowchart :nodes="nodes" :connections="connections" @editnode="handleEditNode" :readonly="false"
      @dblclick="handleDblClick" @editconnection="handleEditConnection" @save="handleChartSave" ref="chart">
    </flowchart>
    <node-dialog @closed="nodeDialogVisible = false" :visible.sync="nodeDialogVisible" :node.sync="nodeForm.target">
    </node-dialog>
    <connection-dialog @closed="connectionDialogVisible = false" :visible.sync="connectionDialogVisible"
      :connection.sync="connectionForm.target" :operation="connectionForm.operation">
    </connection-dialog>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import ConnectionDialog from "../components/ConnectionDialog";
import NodeDialog from "../components/NodeDialog";
import Flowchart from "../components/flowchart/Flowchart";
import processApi from '../../../api/processesApi';
export default {
  name: "flow",
  components: {
    ConnectionDialog,
    NodeDialog,
    Flowchart,
  },
  data: function () {
    return {
      nodes: [
        { id: +new Date(), x: 50, y: 220, name: "Start", type: "start", approvers: [] },
        { id: +new Date() + 1, x: 630, y: 220, name: "End", type: "end", approvers: [] },
      ],
      connections: [],
      nodeForm: { target: null },
      connectionForm: { target: null, operation: null },
      nodeDialogVisible: false,
      connectionDialogVisible: false,
      canUpdateProcess: false,
      isLoading: false,
    };
  },
  methods: {
    handleDblClick(position) {
      this.$refs.chart.add({
        id: +new Date(),
        x: position.x,
        y: position.y,
        name: "Nouveau",
        type: "operation",
        approvers: [],
      });
    },
    async handleChartSave(nodes, connections) {
      // TODO: CHECK DATA INTEGRITY & COMPLIANCE
      this.isLoading = true;
      let loader = this.$loading.show();
      /* eslint-disable no-console */
      const payload = {
        'id': this.$route.params.id,
        'nodes': nodes,
        'connections': connections
      }
      if (this.canUpdateProcess) {
        processApi.updateProcess(payload).then(() => {
          loader.hide();
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
          loader.hide();
        });
      } else {
        processApi.storeProcess(payload).finally(() => {
          loader.hide();
          this.isLoading = false;
        });
      }
    },
    handleEditNode(node) {
      if (node.type !== 'start' && node.type !== 'end') {
        this.nodeForm.target = node;
        this.nodeDialogVisible = true;
      }
    },
    handleEditConnection(connection) {
      const node = this.nodes.filter(e => e.id === connection.source.id);
      if (node.length) {
        this.connectionForm.target = connection;
        this.connectionDialogVisible = true;
      } else {
        this.connectionForm.target = connection;
        this.connectionDialogVisible = true;
      }
    },
  },
  created() {
    /* eslint-disable no-console */
    let loader = this.$loading.show();
    processApi.showProcess(this.$route.params.id).then((response) => {
      if (response.data.nodes.length > 0 && response.data.connections.length > 0) {
        this.nodes = response.data.nodes;
        this.connections = response.data.connections;
        this.canUpdateProcess = true;
      }
      loader.hide();
    })
  },
};
</script>
<style scoped>
  #toolbar {
    border-bottom:4px solid #f1f5fa;
    padding: 10px;
  }
</style>